import axios from 'axios'
import qs from 'qs'
import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/utils/auth'
// // create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV, // url = base url + request url
  // baseURL:'https://twhyz.lzdfsy.com/',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    // config.headers['Content-Type']='application/x-www-form-urlencoded'
    
    return config
  },
  error => {
    // do something with request error
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
	
      Message({
        message: res.info || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
	  return res;
      // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.code ===   50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // console.log('err' + error) // for debug
    Message({
      message: error.msg || '网络连接错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

service.post = function(url,data,option={}){
	let userinfo = JSON.parse(sessionStorage.getItem('user')) ;
	if(!data){
		data = {};
	}
	
	if(userinfo){
		data.uid = userinfo['id'];
	}	
	
	return new Promise(function(resolve,reject){
		
		service({
			url:url,
			method:"POST",
			data:qs.stringify(data),
			...option,
			headers:{"Content-Type":"application/x-www-form-urlencoded",...option.headers},				
		})
		.then(res=>resolve(res))
		.catch(err=>reject(err))
		
	})
}
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js